import { Grid, Typography } from '@mui/material'
import OWNumberInput from 'components/OWForm/OWNumberInput'
import OWSelect, { TOption } from 'components/OWForm/OWSelect'
import { useNewUOMFormContext } from '../hooks/useNewUOMForm'
import { useTranslation } from 'react-i18next'
import { useWatch } from 'react-hook-form'
import { useCallback, useMemo } from 'react'
import { NO_REF_UOM_ID } from '../hooks/useGetUOMAndDependencies'
import HelperTooltip from 'components/Tooltip/HelperTooltip'

function UOMConversionForm({
    uoms,
    currentName,
    hasName,
    disabled,
}: {
    uoms: TOption[]
    currentName: string
    hasName: boolean
    disabled: boolean
}) {
    const { control, setValue } = useNewUOMFormContext()
    const { t } = useTranslation()

    const [referenceUOMID] = useWatch({
        control: control,
        name: ['referenceUOMID'],
    })

    const isBaseUOM = useMemo(() => referenceUOMID === NO_REF_UOM_ID, [
        referenceUOMID,
    ])

    const onChangeRefUOM = useCallback(
        (val: number) => {
            if (val === NO_REF_UOM_ID) {
                setValue('initialUnitForConversion', 1)
                setValue('conversion', 1)
            }
        },
        [setValue],
    )

    return (
        <Grid container spacing={2} alignItems={'center'}>
            <Grid
                item
                xs={12}
                sm={6}
                container
                spacing={1}
                alignItems={'center'}
            >
                <Grid item xs={4}>
                    <OWNumberInput
                        control={control}
                        name={'initialUnitForConversion'}
                        disabled={disabled || isBaseUOM}
                        fullWidth
                    />
                </Grid>
                <Grid item xs="auto">
                    <Typography>
                        {t('uoms.label.unit_of')}{' '}
                        <Typography
                            fontWeight={hasName ? 'bold' : undefined}
                            fontStyle={hasName ? undefined : 'italic'}
                            color={hasName ? 'primary.main' : 'default.dark'}
                            component={'span'}
                        >
                            {currentName}
                        </Typography>
                    </Typography>
                </Grid>
                <Grid item xs>
                    <Typography textAlign={'center'}>=</Typography>
                </Grid>
            </Grid>

            <Grid
                item
                xs={12}
                sm={6}
                container
                alignItems={'center'}
                spacing={1}
            >
                <Grid item xs={4}>
                    <OWNumberInput
                        control={control}
                        name={'conversion'}
                        disabled={disabled || isBaseUOM}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={8}>
                    <HelperTooltip
                        hideHelpIcon={!isBaseUOM}
                        helperText={t('uoms.message.tooltip.no_ref_uom')}
                    >
                        <OWSelect
                            control={control}
                            name="referenceUOMID"
                            options={uoms}
                            onChangeCallback={onChangeRefUOM}
                            fullWidth
                            disabled={disabled}
                        />
                    </HelperTooltip>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default UOMConversionForm
